<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="管理员编辑"></el-page-header>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="账号" prop="account">
                <el-input type="text" v-model="ruleForm.account" placeholder="请输入账号" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input type="password" v-model="ruleForm.password" placeholder="请输入密码"
                          autocomplete="new-password"
                          :disabled="passwordDisabled"
                          style="width: 100%;"></el-input>
                <div class="btns">
                    <el-button type="warning" @click.prevent="changePassword()">修改密码</el-button>
                </div>
            </el-form-item>
            <el-form-item label="确认密码" prop="verifyPass">
                <el-input type="password" v-model="ruleForm.verifyPass" placeholder="请输入确认密码"
                          autocomplete="new-password" style="width: 100%;" :disabled="passwordDisabled"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="mobile">
                <el-input v-model="ruleForm.mobile" placeholder="请输入联系电话" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="email">
                <el-input v-model="ruleForm.email" placeholder="请输入邮箱地址" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="角色" prop="role_id">
                <el-select v-model="ruleForm.role_id" placeholder="请选择角色" style="width: 100%;">
                    <el-option
                            v-for="item in allRole"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="真实姓名" prop="user_name">
                <el-input v-model="ruleForm.user_name" placeholder="请输入真实姓名" style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="所属公司" prop="company_id">
                <el-select @change="changeCompany" v-model="ruleForm.company_id" placeholder="请选择所属公司"
                           v-if="ruleForm.role_id != 3"
                           style="width: 100%;">
                    <el-option
                            v-for="item in allCompany"
                            :key="item.id"
                            :label="item.company_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
                <el-select v-model="ruleForm.company_id" placeholder="请选择所属公司"  v-if="ruleForm.role_id == 3"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allCompany"
                        :key="item.id"
                        :label="item.company_name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属部门" prop="department_id" v-if="ruleForm.role_id != 3">
                <el-select @change="changeDeparment" v-model="ruleForm.department_id"
                           placeholder="请选择部门"
                           style="width: 100%;">
                    <el-option value="">请选择</el-option>
                    <el-option
                            v-for="item in allCompanyDeparment"
                            :key="item.id"
                            :label="item.department_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="所属组" prop="group_id" v-if="ruleForm.role_id != 3">
                <el-select v-model="ruleForm.group_id" placeholder="请选择所属组"
                           style="width: 100%;">
                    <el-option value="">请选择</el-option>
                    <el-option
                            v-for="item in allCompanyGroup"
                            :key="item.id"
                            :label="item.group_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="职务" v-if="ruleForm.role_id == 3">-->
<!--                <el-input type="text" v-model="ruleForm.posistion" placeholder="请输入职务" autocomplete="off"-->
<!--                          style="width: 100%;" ></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="职称" v-if="ruleForm.role_id == 3">-->
<!--                <el-input type="text" v-model="ruleForm.user_title" placeholder="请输入职称（限6字）" autocomplete="off"-->
<!--                          style="width: 100%;" maxlength="6"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item label="专长" v-if="ruleForm.role_id == 3">
                <el-input type="textarea" v-model="ruleForm.introduction" maxlength="80"
                          show-word-limit
                          autosize placeholder="请输入专长" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="头像" v-if="ruleForm.role_id == 3">
                <div class="avatar-uploader">
                    <label class="avatar-btn" for="uploads">
                        <img style=" width: 200px;height: 280px;" v-if="userAvaratImageUrl" :src="userAvaratImageUrl"
                             class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </label>
                </div>
                <input type="file" id="uploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
            </el-form-item>
            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog title="头像裁剪" :visible.sync="dialogVisible" append-to-body @close="closeDialog">
            <div class="cropper-content">
                <div class="cropper" style="text-align:center">
                    <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :autoCrop="true"
                        :fixed="true"
                        :fixedNumber="[5, 7]">
                    </vue-cropper>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <label class="el-button el-button--primary" for="suploads" style="margin-right: 10px;"><span>重新选择</span></label>
                <input type="file" id="suploads" style="position:absolute; clip:rect(0 0 0 0);"
                       accept="image/png, image/jpeg, image/gif, image/jpg" @change="selectImg($event)">
                <el-button type="primary" @click="uploadImg('blob')" :loading="loading">确认</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {check} from "@/utils/checkData";
import {VueCropper} from "vue-cropper";
import env from "@/api/env";
    export default {
        components: {
            VueCropper
        },
        mounted() {
            this.id = this.$route.params.id;
            this.getAllRole();

            this.ruleForm.account = this.$route.params.account;
            let inputPassword = '';
            for (var i = 0; i < this.$route.params.password_len; i++) {
                inputPassword = inputPassword + '*';
            }
            this.oldpassword = this.$route.params.password;
            this.asteriskPassword = inputPassword;
            this.ruleForm.password = inputPassword;
            this.ruleForm.verifyPass = inputPassword;
            this.ruleForm.mobile = this.$route.params.mobile;
            this.ruleForm.email = this.$route.params.email;
            this.ruleForm.user_name = this.$route.params.user_name;
            this.ruleForm.role_id = this.$route.params.role_id;
            this.ruleForm.company_id = this.$route.params.company_id;
            this.changeCompany();
            this.ruleForm.department_id = this.$route.params.department_id;
            this.changeDeparment();
            this.ruleForm.group_id = this.$route.params.group_id;
            this.ruleForm.user_avatar = this.$route.params.user_avatar;
            if (this.$route.params.user_avatar) {
                this.userAvaratImageUrl = this.imgUrl + this.$route.params.user_avatar;
            }
            this.ruleForm.introduction = this.$route.params.introduction
            this.ruleForm.user_title = this.$route.params.user_title
            this.ruleForm.posistion = this.$route.params.posistion



        },
        data() {
            // 验证账户
            var checkAccount = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/[a-zA-Z0-9]/).test(value.slice(0, 1))) {
                        callback(new Error('账号必须以英文字母开头，包含字母与数字，长度不超过32位'));
                    } else {
                        if (!(/^[0-9a-zA-Z]{1,}$/).test(value)) {
                            callback(new Error('账号必须以英文字母开头，包含字母与数字，长度不超过32位'));
                        } else {
                            callback();
                        }
                    }
                }, 1);
            };

            // 验证密码
            var checkPassword = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/^[0-9a-zA-Z_！@#￥%\.&\*]{6,16}$/).test(value) && this.passwordDisabled == false) {
                        callback(new Error('密码可由数字、字母和下划线组成，长度6-16位'));
                    } else {
                        callback();
                    }
                }, 1);
            };

            // 验证手机
            var checkMobil = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/^1[3456789]\d{9}$/).test(value)) {
                        callback(new Error('输入正确的手机号码'));
                    } else {
                        callback();
                    }
                }, 1);
            };

            // 验证Email
            var checkEmail = (rule, value, callback) => {
                setTimeout(() => {
                    if (!(/^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/).test(value)) {
                        callback(new Error('输入正确的Email'));
                    } else {
                        callback();
                    }
                }, 1);
            };

            // 验证确认密码
            var checkVerifyPass = (rule, value, callback) => {
                setTimeout(() => {
                    if (value != this.ruleForm.password) {
                        callback(new Error('密码与确认密码不一致'));
                    } else {
                        callback();
                    }
                }, 1);
            };
            return {
                passwordDisabled: true,
                id: null,
                allRole: [],
                allCompanyDeparment:[],
                allCompanyGroup:[],
                allCompany:[],
                oldpassword: null,
                asteriskPassword: '',
                upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
                userAvaratImageUrl: '',
                imgUrl: env.IMG_COMMON_URL_PREFIX,
                loading: false,
                dialogVisible: false,
                option: {
                    img: '',             //裁剪图片的地址
                },
                ruleForm: {
                    account: "",
                    password: "",
                    verifyPass: "",
                    mobile: "",
                    email: "",
                    role_id: "",
                    user_name: "",
                    company_id:"",
                    group_id:"",
                    department_id:'',
                    introduction: '',
                    posistion: '',
                    user_title: '',
                    user_avatar: '',
                },
                rules: {
                    account: [
                        {required: true, message: "用户名必须以英文字母开头，包含字母与数字，长度不超过32位", trigger: "blur"},
                        {max: 32, message: "用户必须以英文字母开头，包含字母与数字，长度不超过32位", trigger: "blur"},
                        {validator: checkAccount, trigger: 'blur'}
                    ],
                    password: [
                        {required: true, message: "密码可由数字、字母和下划线组成，长度6-16位", trigger: "blur"},
                        {min: 6, max: 16, message: "密码可由数字、字母和下划线组成，长度6-16位", trigger: "blur"},
                        {validator: checkPassword, trigger: 'blur'}
                    ],
                    verifyPass: [
                        {required: true, message: "请输入确认密码", trigger: "blur"},
                        {validator: checkVerifyPass, trigger: 'blur'}
                    ],
                    mobile: [
                        {required: true, message: "请输入联系电话", trigger: "blur"},
                        {min: 11, max: 11, message: "请输入正确的联系电话", trigger: "blur"},
                        {validator: checkMobil, trigger: 'blur'}
                    ],
                    email: [
                        {type: 'email', required: true, message: "请输入邮箱地址", trigger: "blur"},
                        {validator: checkEmail, trigger: 'blur'}
                    ],
                    role_id: [
                        {required: true, message: "请选择角色", trigger: "blur"},
                    ],
                    user_name: [
                        {required: true, message: "请输入真实姓名", trigger: "blur"},
                    ],
                    company_id: [
                        {required: true, message: "请选择所属公司", trigger: "blur"},
                    ]
                },
                is_submit: false,
            };
        },
        methods: {
            // 角色列表
            getAllRole() {
                let params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'allRole',
                };
                this.$api.service(params).then(res => {
                    this.allRole =  res.data.data.filter(function (x) {
                             return x.id !=2;
                         });
                });
                params = {
                    servername: 'Ruyi_AdminSystemServices',
                    method: 'allCompany',
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompany = res.data.data;
                });

            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminSystemServices',
                            'method': 'editAccount',
                            'params': {
                                id: this.id,
                                account: this.ruleForm.account,
                                password: this.ruleForm.password == this.asteriskPassword ? this.oldpassword : this.ruleForm.password,
                                mobile: this.ruleForm.mobile,
                                email: this.ruleForm.email,
                                role_id: this.ruleForm.role_id,
                                user_name: this.ruleForm.user_name,
                                company_id:this.ruleForm.company_id,
                                department_id:this.ruleForm.department_id,
                                group_id:this.ruleForm.group_id,
                                introduction: this.ruleForm.introduction,
                                posistion: this.ruleForm.posistion,
                                user_title: this.ruleForm.user_title,
                                user_avatar: this.ruleForm.user_avatar,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (res.data.code != 0) {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg
                                });
                                this.is_submit = false;
                            } else {
                                this.$message({
                                    type: "success",
                                    message: '编辑成功',
                                    duration: 1500,
                                    onClose: function () {
                                        _that.is_submit = false;
                                        window.history.go(-1);
                                    }
                                });
                            }
                        }).catch(() => {
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
                this.is_submit = false;
            },

            // 修改密码
            changePassword() {
                this.passwordDisabled = false;
                this.ruleForm.password = '';
                this.ruleForm.verifyPass = '';
            },
            changeCompany() {
                this.ruleForm.department_id = '';
                this.ruleForm.group_id = '';
                this.getAllDeparment();
            },
            changeDeparment() {
                this.ruleForm.group_id = '';
                this.getAllCompanyGroup();
            },
            getAllDeparment() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyDeparment',
                    params: {
                        company_id: this.ruleForm.company_id,
                        status: 1
                    }
                };
                this.allCompanyDeparment = [];
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyDeparment = res.data.data;
                });
            },

            getAllCompanyGroup () {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllCompanyGroup',
                    params: {
                        company_id: this.ruleForm.company_id,
                        department_id: this.ruleForm.department_id,
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCompanyGroup = res.data.data;
                });
            },
            //选择图片
            selectImg(e) {
                let file = e.target.files[0]

                if (!/\.(jpg|jpeg|png|JPG|PNG)$/.test(e.target.value)) {
                    this.$message({
                        message: '图片类型要求：jpeg、jpg、png',
                        type: "error"
                    });
                    return false
                }
                //转化为blob
                let reader = new FileReader()
                reader.onload = (e) => {
                    let data
                    if (typeof e.target.result === 'object') {
                        data = window.URL.createObjectURL(new Blob([e.target.result]))
                    } else {
                        data = e.target.result
                    }
                    this.option.img = data
                    this.dialogVisible = true;
                }
                //转化为base64
                reader.readAsDataURL(file)
            },
            //上传图片
            uploadImg(type) {
                let _this = this;
                if (type === 'blob') {
                    //获取截图的blob数据
                    this.$refs.cropper.getCropBlob(async (data) => {

                        let formData = new FormData();
                        formData.append('file', data, ".jpg")

                        await _this.$api.avatar_upload_file(formData).then(res => {
                            if (!check(res)) {
                                return;
                            }
                            if (res.data.code == 0) {
                                _this.ruleForm.user_avatar = res.data.data;
                                _this.userAvaratImageUrl = this.imgUrl + res.data.data;
                                _this.dialogVisible = false;
                            } else {
                                _this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                });
                            }
                        })

                    })
                }
            },
            // 关闭对话框清除之前选择的文件
            closeDialog() {
                document.getElementById('uploads').value = ''
                document.getElementById('suploads').value = ''
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .cropper-content {
        .cropper {
            width: auto;
            height: 280px;
        }
    }

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-btn, .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-btn, .avatar-uploader .el-upload:hover {
        border-color: #d9d9d9;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px !important;
        height: 280px;
        line-height: 280px;
        text-align: center;
    }

    .avatar-btn {
        display: inline-block;
        text-align: center;
        width: 200px;
        height: 280px;
    }

    .editor {
        line-height: normal !important;
        height: 800px;
    }

</style>
